import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { GenericDocContainerModel } from "../../../../../../models/aggregates/generic_doc";
import { Observable } from "rxjs";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  Pagination,
  PagingResponseModel,
} from "../../shared";

@Injectable({ providedIn: "root" })
export class InternalSalesRMAService extends BaseApiTemplateService<GenericDocContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.GENERIC_PREFIX +
      "internal-sales-rma";
    this.httpClient = http;
  }
  getLinesByCriteria(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/type`;
    }
    const UrlByCriteria =
      this.apiUrl + "/query?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public printJasperPdf(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    customParam?: string): Observable<Blob> {
    let params;
    let url;
    if (customParam) {
      params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid)
        .set('customParam', customParam);
    } else {
      params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid);
    }
    url = apiVisa.api_domain_url + this.endpoint_path + '/print-jasper-pdf/' + guid;
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }
  
  public printPdf(
    guid: string,
    templateDocId: string,
    printServiceClassName: string,
    apiVisa: ApiVisa
  ): Observable<Blob> {
    return this.httpClient.get<Blob>(this.apiUrl + "/print-pdf/" + guid, {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        responseType: "blob",
        tenantCode: apiVisa.tenantCode,
      }),
      params: new HttpParams()
        .set("templateDocId", templateDocId)
        .set("printServiceClassName", printServiceClassName),
      responseType: "blob" as "json",
    });
  }
}
